// navTabsConfig.js

export const getNavTabs = ({ counts = {} }) => {
    const {
        demographicsCount = 0,
        conditionsCount = 0,
        tagsCount = 0
    } = counts;

    return [
        {
            id: "dashboard",
            label: "Dashboard",
            badge: null,
            href: "/dashboard?_tab=dashboard",
            permission: "dashboard"
        },
        {
            id: "demographics",
            permission: "demographics",
            label: "Demographics",
            badge: demographicsCount,
            href: "/patient-list?_tab=demographics",
        },
        {
            id: "conditions",
            permission: "conditions",
            label: "Conditions",
            badge: conditionsCount,
            href: "/patient-list?_tab=conditions",
        },
        // ...(!settings.hideTagSelector && !query.params._id ? [{
        //     id: "tags",
        //     permission: "demographics",
        //     label: "Tags",
        //     badge: tagsCount,
        //     href: "#/patient-list?_tab=tags",
        // }] : []),
        {
            id: "search",
            permission: "fhirSearch",
            label: "FHIR Search",
            badge: null,
            href: "/fhir-search?_tab=search"
        },
        {
            id: "view",
            permission: "views",
            label: "Views",
            badge: null,
            href: "/view?_tab=view&_resource=patients"
        },
        {
            id: "claimTracker",
            permission: "claimTracker",
            label: "Claim Tracker",
            badge: null,
            href: "/claim-tracker?_tab=claimTracker"
        },
        {
            id: "claimReview",
            permission: "claimReview",
            label: "Claim Review",
            badge: null,
            href: "/claim-review?_tab=claimReview"
        },
        {
            id: "closedLoop",
            permission: "clr",
            label: "CLR",
            badge: null,
            href: "/closed-loop?_tab=closedLoop"
        },
        {
            id: "leadsSummary",
            permission: "leadsSummary",
            label: "Leads Summary",
            badge: null,
            href: "/leads-summary?_tab=leadsSummary"
        },
        {
            id: "membersSummary",
            permission: "membersSummary",
            label: "Members Summary",
            badge: null,
            href: "/members-summary?_tab=membersSummary"
        },
        {
            id: "trafficCop",
            permission: "trafficCop",
            label: "Traffic Cop",
            badge: null,
            href: "/traffic-cop?_tab=trafficCop"
        },
        {
            id: "preScreening",
            permission: "preScreening",
            label: "Pre-screening",
            badge: null,
            href: "/pre-screening?_tab=preScreening"
        },
        {
            id: "mortalityAlert",
            permission: "mortalityAlert",
            label: "Mortality Alert",
            badge: null,
            href: "/mortality-alert?_tab=mortalityAlert"
        },
    ];
};
